import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import themesVariables from "./themesVariables";
import { IUiSettings } from "../models/admin/uiSettings/uiSettings";

const createAppTheme = (uiSettings: IUiSettings | null) =>
  createTheme({
    palette: {
      mode: "light",
      primary: {
        light:
          uiSettings?.lightPrimaryLightColor ||
          themesVariables.lightPrimaryLightColor,
        main:
          uiSettings?.lightPrimaryMainColor ||
          themesVariables.lightPrimaryMainColor,
        dark:
          uiSettings?.lightPrimarydarkColor ||
          themesVariables.lightPrimarydarkColor,
        contrastText:
          uiSettings?.lightSecondaryContrastTextColor ||
          themesVariables.lightPrimaryContrastTextColor,
      },
      secondary: {
        light:
          uiSettings?.lightSecondaryLightColor ||
          themesVariables.lightSecondaryLightColor,
        main:
          uiSettings?.lightSecondaryMainColor ||
          themesVariables.lightSecondaryMainColor,
        dark:
          uiSettings?.lightSecondaryDarkColor ||
          themesVariables.lightSecondaryDarkColor,
        contrastText:
          uiSettings?.lightSecondaryContrastTextColor ||
          themesVariables.lightSecondaryContrastTextColor,
      },
      error: {
        main: red.A400,
      },
    },
    typography: {
      fontFamily: uiSettings?.fontFamily || themesVariables.fontFamily,
      fontSize: uiSettings?.fontSize || themesVariables.fontSize,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            letterSpacing: "1px",
            textTransform: "none",
            borderRadius: "50px",
            boxShadow: "0px 6px 10px 0px rgba(63, 63, 63, 0.3)",
            "&.Mui-disabled": {
              backgroundColor: `${themesVariables.lightPrimaryLightColor} !important`,
              color: themesVariables.lightPrimaryContrastTextColor,
              cursor: "not-allowed",
              pointerEvents: "auto",
            },
            "&:hover": {
              backgroundColor:
                uiSettings?.lightSecondaryMainColor ||
                themesVariables.lightPrimaryMainColor,
              color:
                uiSettings?.lightSecondaryContrastTextColor ||
                themesVariables.lightPrimaryContrastTextColor,
            },
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            cursor: "pointer",
          },
        },
      },
    },
  });

export { createAppTheme };
